var _defs, _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelosWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 783.45 263.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n\n      .st1 {\n        fill: #0f2e54;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 129.42,
    x2: 781.09,
    y2: 129.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0f2e54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00adff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M767.5,84.75c-50.04-25.01-102.59-44.76-156.52-58.92C557.02,11.8,501.68,3.55,446.2.87c-110.95-5.2-222.62,12.98-325.52,52.91-12.19,4.7-24.22,9.71-36.1,15.01,5.51-5.3,10.96-9.15,17.53-13.25v-24.02l-30.03,5.46v37.53c-22.67,10.61-44.78,22.29-66.37,35.05,0,0,0,0,.01,0C2.3,111.61,0,115.33,0,119.61c0,6.45,5.23,11.68,11.68,11.68,2.05,0,3.98-.53,5.65-1.46,18.02-9.88,36.22-18.91,54.75-27.18v103.8c0,33.17,20.25,52.38,56.21,52.38l17.26-.12,4.38-27.46h-17.46c-18.86,0-30.38-11.52-30.38-29.68v-111.51c9.27-3.65,18.64-7.13,28.12-10.43,100.53-35.22,208.07-48.96,313.59-40.5,52.73,4.31,104.92,13.88,155.45,28.83,50.5,15.06,99.33,35.32,145.51,60.33l.14.08c.21.11.41.22.63.32,12.13,6.06,26.88,1.14,32.94-10.99,6.06-12.13,1.14-26.88-10.99-32.94Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 756.63,
    cy: 106.79,
    r: 24.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.49,76.56c-53.77,0-94.63,40.16-94.63,93.23s40.86,93.23,95.68,93.23c41.9,0,76.47-23.04,90.44-57.27h-34.5c-11.41,17.84-30.8,27.75-55.59,27.75-33.52,0-56.84-21.39-61.07-51.14h153.59c.35-3.84.7-8.38.7-12.57,0-53.07-40.5-93.23-94.63-93.23ZM187.83,155.48c5.7-29.17,29.17-49.29,59.68-49.29s55.33,20.79,60.36,49.29h-120.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.04,49.22v209.61h39.1V49.73c-12.99-.51-26.02-.67-39.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525.13,76.56c-54.47,0-95.32,40.16-95.32,93.23s40.85,93.23,95.32,93.23,95.32-40.15,95.32-93.23-41.2-93.23-95.32-93.23ZM525.12,223.5c-30.39,0-53.37-23.3-53.37-53.7s22.97-53.7,53.37-53.7,53.03,23.3,53.03,53.7-22.63,53.7-53.03,53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.38,128.94c0-9.08,9.43-15.36,23.4-15.36,4.81,0,7.7.79,10.53,2.03-18.81-9.32-38.01-17.87-57.55-25.63-13.5,9.66-21.77,24.28-21.77,43.15,0,63.9,96.72,47.14,96.72,76.12,0,9.43-10.48,16.41-25.49,16.41-16.41,0-28.28-8.03-28.28-20.25h-45.74c0,33.52,29.68,57.62,74.03,57.62s71.23-23.39,71.23-58.31c0-63.9-97.07-47.49-97.07-75.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelosWordmark);
export default __webpack_public_path__ + "static/media/telos-wordmark.abb5ee43b7d167ced8a5b93103b2ce8c.svg";
export { ForwardRef as ReactComponent };